import { Injectable, inject } from '@angular/core';

import { SportsProductMenuConfig } from '@frontend/sports/common/client-config-data-access';
import { CriticalErrorComponent } from '@frontend/sports/critical-error/feature';
import {
    AdaptiveLayoutService,
    ColumnLayoutService,
    DeviceLayoutProvider,
    FixedLayout,
    Layout,
    ResponsiveLayout,
    RightColumnLayoutProvider,
    RouteLayoutProvider,
} from '@frontend/sports/layout/feature';
import { DeviceService, DynamicLayoutService, OnAppInit } from '@frontend/vanilla/core';
import { ProductMenuService } from '@frontend/vanilla/shared/product-menu';

import { BetslipBarContainerComponent } from '../bottom-nav/betslip-bar-container.component';
import { BreadcrumbLayoutProvider } from '../breadcrumbs/breadcrumb-layout.provider';
import { SportsProductMenuVersion } from '../sports-product-menu/sports-product-menu.enum';
import { SubNavigationLayoutProvider } from '../sub-navigation/sub-navigation-layout.provider';
import { SportsProductMenuLoaderService } from './sports-product-menu-loader.service';

@Injectable({
    providedIn: 'root',
})
export class LayoutBootstrapService implements OnAppInit {
    private dynamicLayoutService = inject(DynamicLayoutService);
    private adaptiveLayoutService = inject(AdaptiveLayoutService);
    private deviceLayoutProvider = inject(DeviceLayoutProvider);
    private routeLayoutProvider = inject(RouteLayoutProvider);
    private breadcrumbLayoutProvider = inject(BreadcrumbLayoutProvider);
    private subNavigationLayoutProvider = inject(SubNavigationLayoutProvider);
    private productMenuService = inject(ProductMenuService);
    private columnBootstrap = inject(ColumnLayoutService);
    private rightColumnLayoutProvider = inject(RightColumnLayoutProvider);
    private deviceService = inject(DeviceService);
    private sportsProductMenuConfig = inject(SportsProductMenuConfig);
    private sportsProductMenuLoaderService = inject(SportsProductMenuLoaderService);

    private readonly productMenu = 'sports-all-layout';

    onAppInit(): void {
        this.dynamicLayoutService.addComponent('app', CriticalErrorComponent);
        this.dynamicLayoutService.addComponent('app', BetslipBarContainerComponent);

        this.columnBootstrap.initializeLayout(this.createLayout());

        this.adaptiveLayoutService.register(
            this.deviceLayoutProvider,
            this.routeLayoutProvider,
            this.breadcrumbLayoutProvider,
            this.subNavigationLayoutProvider,
            this.rightColumnLayoutProvider,
        );

        if (this.sportsProductMenuConfig.version === SportsProductMenuVersion.V2) {
            this.sportsProductMenuLoaderService.loadAndInitModule().subscribe((m) => {
                this.productMenuService.setProductMenuComponent(this.productMenu, m.sportsProductMenuComponent);
            });
        } else {
            import('../sport-list/product-menu-sport-list.component').then((m) => {
                this.productMenuService.setProductMenuComponent(this.productMenu, m.ProductMenuSportListComponent);
            });
        }
    }

    private createLayout(): Layout {
        if (this.deviceService.isMobilePhone) {
            return new FixedLayout(1);
        }

        return new ResponsiveLayout(3);
    }
}
